import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIntellijideaComponent } from './simple-icons-intellijidea.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIntellijideaComponent ],
    exports:      [ SimpleIconsIntellijideaComponent ],
    bootstrap:    []
})
export class SimpleIconsIntellijideaModule {}
